(function () {
  'use strict';
  const esc = v => String(v || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const labels = {PV:'Nur Photovoltaik', WP:'Nur Wärmepumpe', PV_WP:'PV + Wärmepumpe'};
  const queryTypes = {pv:'PV', wp:'WP', kombi:'PV_WP'}, queryValues = {PV:'pv', WP:'wp', PV_WP:'kombi'};
  const badge = t => '<span class="pvpm-badge" data-category="' + esc(t) + '">' + esc(labels[t] || t) + '</span>';

  function init(root) {
    if (root.dataset.initialized) return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-project-map-data]').textContent); } catch { return; }
    const regions = data.regions || [], tools = root.querySelector('.pvpm-tools');
    const status = root.querySelector('.pvpm-map-status'), mapNode = root.querySelector('.pvpm-map');
    const fallback = root.querySelector('[data-project-fallback]'), tabs = [...root.querySelectorAll('[data-project-filter]')];
    const available = new Set(regions.flatMap(r => r.projects.map(p => p.type)));
    let selectedType = 'all', map, clusters, loadedTiles = 0, tileTimer, lastBounds = [];
    for (const r of regions) {
      r.image = r.image?.startsWith('http') ? r.image : (data.imagePrefix || '') + r.image;
      for (const v of Object.values(r.views || r.tradeViews || {})) v.image = v.image?.startsWith('http') ? v.image : (data.imagePrefix || '') + v.image;
      for (const p of r.projects) {
        if (p.url?.startsWith('#')) p.url = r.url + p.url;
        if (p.image && !p.image.startsWith('http')) p.image = (data.imagePrefix || '') + p.image;
      }
    }
    for (const btn of tabs) {
      const t = btn.dataset.projectFilter;
      const count = t === 'all' ? data.totalProjects : (data.categoryCounts?.[t] || regions.flatMap(r => r.projects).filter(p => p.type === t).length);
      btn.querySelector('[data-filter-count]').textContent = count;
      btn.disabled = count === 0;
    }
    function popup(r, projects) {
      const selected = selectedType === 'all' ? projects[0]?.type : selectedType;
      const v = r.views?.[selected] || r.tradeViews?.[selected] || r;
      const image = projects[0]?.image || v.image;
      return '<div class="pvpm-pop"><img src="' + esc(image) + '" alt="Projektfoto aus ' + esc(r.city) + '"><strong>' + esc(r.city) + '</strong><p>' + projects.length + ' ' + (projects.length === 1 ? 'Projekt' : 'Projekte') + '</p><ul>' + projects.map(p => '<li>' + badge(p.type) + '<a href="' + esc(p.url) + '">' + esc(p.title) + '</a></li>').join('') + '</ul></div>';
    }
    function counts(projects) { return projects.reduce((c,p) => (c[p.type] = (c[p.type] || 0) + 1,c), {}); }
    function icon(n,c) {
      const ts = Object.keys(c), category = ts.length === 1 ? ts[0] : 'mixed';
      let fill = '', at = 0;
      for (const t of ['PV','WP','PV_WP']) if (c[t]) {
        const start = at; at += c[t] / n * 100;
        const color = t === 'PV' ? 'var(--map-yellow)' : t === 'WP' ? 'var(--map-blue)' : 'var(--map-combo)';
        fill += (fill ? ',' : '') + color + ' ' + start + '% ' + at + '%';
      }
      return L.divIcon({className:'pvpm-pin-wrap',html:'<span class="pvpm-pin" data-category="' + category + '"' + (ts.length > 1 ? ' style="--pin-fill:conic-gradient(' + fill + ')"' : '') + '><span>' + n + '</span></span>',iconSize:[46,46],iconAnchor:[23,23],popupAnchor:[0,-25]});
    }
    function update(sync = true) {
      const bounds = [];
      clusters.clearLayers();
      for (const btn of tabs) btn.setAttribute('aria-pressed', String(btn.dataset.projectFilter === selectedType));
      for (const r of regions) {
        const projects = r.projects.filter(p => selectedType === 'all' || p.type === selectedType);
        if (!projects.length) continue;
        const c = counts(projects), title = r.city + ' · ' + Object.entries(c).map(([k,v]) => v + ' ' + labels[k]).join(' · ');
        const marker = L.marker([r.lat,r.lng], {icon:icon(projects.length,c),title,alt:title,keyboard:true})
          .bindPopup(popup(r,projects), {maxWidth:300,maxHeight:330,autoPanPadding:[20,20]})
          .bindTooltip(title, {direction:'top',offset:[0,-23]});
        marker.projectCount = projects.length; marker.categoryCounts = c;
        clusters.addLayer(marker); bounds.push([r.lat,r.lng]);
      }
      lastBounds = bounds;
      if (bounds.length) map.fitBounds(bounds, {padding:[44,44],maxZoom:8,animate:false});
      if (sync) {
        const u = new URL(location.href);
        if (selectedType === 'all') u.searchParams.delete('art'); else u.searchParams.set('art',queryValues[selectedType]);
        u.searchParams.delete('ort');
        history.replaceState(null,'',u);
      }
    }
    function showFallback() {
      tools.hidden = true; mapNode.hidden = true; fallback.hidden = false; status.hidden = false;
      status.textContent = 'Die Karte ist gerade nicht verfügbar. Hier finden Sie die Projektberichte nach Ort.';
    }
    function fromURL() {
      const t = queryTypes[new URL(location.href).searchParams.get('art')] || 'all';
      selectedType = available.has(t) ? t : 'all'; update(false);
    }
    if (!window.L || !L.markerClusterGroup) { showFallback(); root.dataset.initialized = 'fallback'; return; }
    try {
      mapNode.hidden = false;
      map = L.map(mapNode,{scrollWheelZoom:false,zoomControl:true,minZoom:4,maxZoom:12}).setView([52.1,8.5],6);
      root._projectMap = map;
      const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {maxZoom:12,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
      tiles.on('tileload', () => { loadedTiles++; status.hidden = true; fallback.hidden = true; });
      tileTimer = setTimeout(() => {
        if (!loadedTiles) { status.hidden = false; fallback.hidden = false; status.textContent = 'Der Kartenhintergrund konnte nicht geladen werden. Die Projektberichte finden Sie auch über die folgenden Ortslinks.'; }
      },8000);
      clusters = L.markerClusterGroup({maxClusterRadius:52,showCoverageOnHover:false,animate:false,disableClusteringAtZoom:10,iconCreateFunction:cluster => {
        const c = {}; let n = 0;
        for (const m of cluster.getAllChildMarkers()) { n += m.projectCount; for (const [k,v] of Object.entries(m.categoryCounts)) c[k] = (c[k] || 0) + v; }
        return icon(n,c);
      }});
      map.addLayer(clusters); tools.hidden = false;
      tabs.forEach(btn => btn.addEventListener('click', () => { selectedType = btn.dataset.projectFilter; update(); }));
      fromURL(); window.addEventListener('popstate',fromURL);
      let observer;
      if (window.ResizeObserver) { observer = new ResizeObserver(() => { map.invalidateSize({pan:false}); if (lastBounds.length) map.fitBounds(lastBounds,{padding:[44,44],maxZoom:8,animate:false}); }); observer.observe(mapNode); }
      root._projectMapCleanup = () => { clearTimeout(tileTimer); observer?.disconnect(); window.removeEventListener('popstate',fromURL); map.remove(); };
      root.dataset.initialized = 'true';
    } catch { clearTimeout(tileTimer); map?.remove(); showFallback(); root.dataset.initialized = 'fallback'; }
  }
  function boot() { document.querySelectorAll('[data-project-map]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',e => e.target.querySelectorAll('[data-project-map]').forEach(r => r._projectMapCleanup?.()));
})();
